export default "/_next/static/images/service-walk-desktop-3x-cea3ff136c136c1227d9e0eb93d77dbd.jpg";